enum TokenInterceptorMessages {
    SessionExpired = 'session-expired',
    NoSessionForToken = 'no-session-for-token',
    // eslint-disable-next-line quotes
    TokenMissing = "headers must have required property 'x-session-token'",
    TokenFormatWrong = 'headers/x-session-token must match format "uuid"'
}

export { TokenInterceptorMessages };
